export default "__VITE_ASSET__DbA5ftGX__"